<template>
    <div class="row left-nav-collapsible">
        <div v-if="detailPageOpen" id="detail-page-open">
            <button class="btn details-open-btn" type="button" @click="onDetailPageOpenClose(false)">
                <span> <i class="fa fa-caret-right"></i></span>
            </button>
        </div>
        <TransitionGroup :name="'slide'" key="detail">
            <div v-if="showCloseBtn && !detailPageOpen" id="detail-page-close" key="close">
                <button class="btn text-start details-open-btn" type="button" @click="onDetailPageOpenClose(true)">
                    <span> <i class="fa fa-caret-left"></i></span>
                </button>
            </div>
            <div v-if="!detailPageOpen" id="details-col" @mouseover="onDetailPageHover(true)" key="details-col">
                <div class="card" v-if="chat">
                    <div class="card-header">
                        <h5 class="card-header-title">Details</h5>
                        <button type="button" data-bs-toggle="collapse" href="#collapse-details-div" aria-expanded="true" aria-controls="collapse-details-div" id="collapse-btn" class="btn  btn-sm"> <i class="fa fa-chevron-up float-end"></i></button>
                    </div>
                    <div id="collapse-details-div" class="collapse show" aria-labelledby="collapse-btn-1" >
                        <div class="card-body p-3">
                            <input-field :editable="false" :label="'ID'" type="text"
                                :modelValue="chat.resourceId" :toolTip="'Chat Id'" />
                            <input-field :editable="false" :label="'Title'" type="text"
                                :modelValue="chat.title" :toolTip="'Chat Title'" />
                            <input-field :editable="false" :label="'Mode'" type="text"
                                :modelValue="mode" :toolTip="'Job type generated(Mapper/PySpark/DBT)'" />
                            <input-field :editable="false" :label="'User'" type="text"
                                :modelValue="chat.userId" :toolTip="'User Email'" />
                            <input-field :editable="false" :label="'Created At'" type="text"
                                :modelValue="DateTimeFormat(chat.createdAt)" :toolTip="'Created Timestamp'" />
                            <input-field :editable="false" :label="'Updated At'" type="text"
                                :modelValue="DateTimeFormat(chat.updatedAt)" :toolTip="'Updated Timestamp'" />
                            <div class="text-end">
                                <button class="btn btn-primary btn-sm me-2" @click="showinputFile">
                                    Input File
                                </button>
                                <button class="btn btn-danger btn-sm" @click="deleteChat">
                                    <i class="fa-regular fa-trash-can"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-if="loading" class="card card-body">
                        <div class="text-center py-2">
                            <div class="spinner-border mb-2" role="status" style="width: 1.5em; height: 1.5em; opacity: 0.5;">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <p class="text-muted mb-0">Loading chat data...</p>
                        </div>
                    </div>
                    <div v-else class="text-center card card-body">
                        <div class="text-muted mb-2">
                            <i class="fa-solid fa-circle-exclamation" style="font-size: 1.5rem; opacity: 0.5;"></i>
                        </div>
                        <p class="text-muted mb-0">{{ !chat ? 'No chat found' : 'No data found' }}</p>
                    </div>
                </div>
            </div>
            <div class="col" id="main-col" @mouseover="onDetailPageHover(false)" key="main-col">
                <div v-if="chat && messages">
                    <div v-if="customInstructions || customSchema" class="mb-3 custom-instr-container">
                        <div class="d-flex align-items-center justify-content-between p-2 px-3 custom-instr collapsed" data-bs-toggle="collapse" data-bs-target="#customConfigCollapse" 
                            aria-expanded="false" aria-controls="customConfigCollapse">
                            <div class="d-flex align-items-center gap-2">
                                <span class="fw-semibold text-dark me-1">Custom Configurations</span>
                                <i class="fa-solid fa-chevron-down text-muted custom-collapse-arrow-down" style="font-size: 0.75rem; margin-top: 0.1rem;"></i>
                                <i class="fa-solid fa-chevron-up text-muted custom-collapse-arrow-up" style="font-size: 0.75rem; margin-top: 0.15rem;"></i>
                            </div>
                            <div>
                                <span v-if="customInstructions" class="custom-config-badge fs-5">
                                    <i class="fa-solid fa-circle-check"></i>
                                    Custom Instructions
                                </span>
                                <span v-if="customSchema" class="custom-config-badge fs-5 ms-2">
                                    <i class="fa-solid fa-circle-check"></i>
                                    Custom Schema
                                </span>
                            </div>
                        </div>

                        <div class="collapse" id="customConfigCollapse">
                            <div class="p-3">
                                <div class="form-group fs-5 inline-field row me-2" rows="4">
                                    <label class="col-sm-3 col-form-label fs-5">
                                        <span class="me-1">Custom Instructions</span>
                                        <i class="fa-solid fa-circle-info text-muted" data-bs-toggle="tooltip" data-bs-placement="right" title="Custom instructions given"></i>
                                    </label>
                                    <div class="border border-dashed col p-0 rounded">
                                        <textarea class="form-control fs-5 w-100" type="text" rows="3" v-model="customInstructions" :disabled="true" :readonly="true" 
                                            placeholder="No custom instructions given">
                                        </textarea>
                                    </div>
                                </div>
                                <div class="form-group fs-5 inline-field row me-2">
                                    <label class="col-sm-3 col-form-label fs-5">
                                        <span class="me-1">Custom Schema</span>
                                        <i class="fa-solid fa-circle-info text-muted" data-bs-toggle="tooltip" data-bs-placement="right" title="Custom schema given for the mapping process"></i>
                                    </label>
                                    <CodemirrorEditor class="form-control col fs-5" :editorId="`mmd-custom-configuration`" :modelValue="customSchema" mode="yaml"
                                        :disabled="true" :readOnly="true" :performLint="false" :maxHeight="'200px'">
                                    </CodemirrorEditor>
                                </div>
                            </div>
                        </div>
                    </div>
                    <tabs :tabs="tabItems" :btnTabs="true">
                        <template v-slot:audit>
                            <div v-if="auditReport" class="card">
                                <div class='card-body markdown-content custom-class'>
                                    <Markdown :content="auditReport" />
                                </div>
                            </div>
                            <div v-else class="card card-body text-center">
                                No data found!
                            </div>
                        </template>
                        <template v-slot:mapper>
                            <div v-if="textResponse">
                                <div class="row">
                                    <div class="col-4">
                                        <div class="card">
                                            <div class='card-body custom-class'>
                                                <div v-if="textResponse" class="float-end">
                                                    <button class="btn btn-primary btn-sm" @click="showModal({ component: 'mapperDetailView', data: { response: { text_response: textResponse }, screenlarge: true } })">
                                                        <i class="fa fa-up-right-and-down-left-from-center"></i>
                                                    </button>
                                                </div>
                                                <Markdown :content="textResponse" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-8">
                                        <job-editor v-model="yamlContent" :activeTab="activeFileTab" :customHeight="'100%'"></job-editor>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="card card-body text-center">
                                No data found!
                            </div>
                        </template>
                        <template v-slot:advisor>
                            <div v-if="advisorResponse" class="card">
                                <div class='card-body markdown-content custom-class'>
                                    <Markdown :content="advisorResponse"></Markdown>
                                </div>
                            </div>
                            <div v-else class="card card-body text-center">
                                No data found!
                            </div>
                        </template>
                        <template v-slot:graph>
                            <div class="card">
                                <div class='card-body'>
                                    <div ref="graphContainer" class="graph-container d-flex justify-content-center">
                                    </div>
                                </div>
                            </div>
                        </template>
                    </tabs>
                </div>
                <div v-else>
                    <div v-if="loading || messageLoading" class="card card-body">
                        <div class="text-center py-2">
                            <div class="spinner-border mb-2" role="status" style="width: 1.5em; height: 1.5em; opacity: 0.5;">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <p class="text-muted mb-0">Loading chat messages...</p>
                        </div>
                    </div>
                    <div v-else class="text-center card card-body">
                        <div class="text-muted mb-2">
                            <i class="fa-solid fa-circle-exclamation" style="font-size: 1.5rem; opacity: 0.5;"></i>
                        </div>
                        <p class="text-muted mb-0">{{ !chat ? 'No chat found' : !messages ? 'No messages in chat' : 'No data found' }}</p>
                    </div>
                </div>
            </div>
        </TransitionGroup>
    </div>
</template>
<script>
import Tabs from "../../components/Tabs.vue";
import Markdown from "../../components/Markdown.vue";
import CodemirrorEditor from "../../components/CodemirrorEditor.vue";
import JobEditor from "../../components/sandbox/JobEditor.vue";
import { DateTimeFormat, relativeTime } from '../../utils/commonFunction';
import InputField from "../../components/InputField.vue";
import { mapActions } from 'vuex'
import { nextTick } from "vue";
import dayjs from 'dayjs'
import * as d3 from "d3";
export default {
    name: "Map My Data Invocations",
    components: { Tabs, Markdown, JobEditor, InputField, CodemirrorEditor },
    data() {
        return {
            loading: false,
            showCloseBtn: false,
            detailPageOpen: false,
            tabItems: [
                {
                    name: "Audit",
                    id: "id1",
                    slot: "audit"
                },
                {
                    name: "Mapping Config",
                    id: "id2",
                    slot: "mapper"
                },
                {
                    name: "Advisor",
                    id: "id3",
                    slot: "advisor"
                },
                {
                    name: "Graph",
                    id: "id4",
                    slot: "graph",
                    onClick: () => {
                        nextTick().then(() => {
                            this.drawGraph(this.graphResponse)
                        })
                    }
                },
            ],

            chat: null,
            messages: null,
            messageLoading: false,
        }
    },
    computed: {
        mode() {
            if (this.messages && this.messages.length >= 1) {
                let mode = this.messages[0].content?.mode;
                switch (mode) {
                    case "mapper":
                        return "Mapper";
                    case "pyspark":
                        return "PySpark";
                    case "dbt":
                        return "DBT";
                    default:
                        return "";
                }
            }
            return ""
        },
        fileType() {
            if (this.messages && this.messages.length >= 1) {
                let file_type = this.messages[0].content?.file_type
                return file_type ? file_type : "csv";
            }
            return ""
        },
        inputFile() {
            if (this.messages && this.messages.length >= 1) {
                let file = this.messages[0].content?.file_content
                return file ? file : null;
            }
            return null
        },
        textResponse() {
            if (this.messages && this.messages.length >= 2) {
                let textResponse = this.messages[1].content?.text_response
                return textResponse ? textResponse : null;
            }
            return null
        },
        auditReport() {
            if (this.messages && this.messages.length >= 1) {
                let auditReport = this.messages[0].content?.audit_report
                return auditReport ? auditReport : null;
            }
            return null
        },
        yamlContent() {
            if (this.messages && this.messages.length >= 2) {
                let generatedFiles = this.messages[1].content?.files
                let files = {}
                if (generatedFiles) {
                    for (const file of generatedFiles) {
                        files[file.name] = file.content ? file.content : ""
                    }
                }
                return files
            }
            return {}
        },
        activeFileTab() {
            if (this.messages && this.messages.length >= 2) {
                let generatedFiles = this.messages[1].content?.files
                return generatedFiles ? generatedFiles[0].name : ""
            }
            return ""
        },
        advisorResponse() {
            if (this.messages && this.messages.length >= 2) {
                let advisorResponse = this.messages[1].content?.advisor_response
                return advisorResponse ? advisorResponse : null;
            }
            return null
        },
        graphResponse() {
            if (this.messages && this.messages.length >= 2) {
                let graphResponse = this.messages[1].content?.graph_response
                return graphResponse ? graphResponse : null;
            }
            return null
        },
        customInstructions() {
            if (this.messages && this.messages.length >= 1) {
                let customInstructions = this.messages[0].content?.custom_instructions
                return customInstructions ? customInstructions : null;
            }
            return null
        },
        customSchema() {
            if (this.messages && this.messages.length >= 1) {
                let customSchema = this.messages[0].content?.custom_schema
                return customSchema ? customSchema : null;
            }
            return null
        },
    },
    methods: {
        ...mapActions({
            showModal: "showModal",
            getChat: "amdp/getChat",
            getChatMessages: "amdp/getChatMessages",
        }),
        async fetchChatHistory() {
            this.loading = true;
            await this.getChat({ feature: "map_my_data", resourceId: this.$route.params.id }).then((response) => {
                this.chat = response.data ? response.data : null;
                this.$emit("setChat", this.chat);
                this.fetchChatHistoryMessages();
            }).catch((error) => {
                console.error("Error getting chat: ", error);
                let toastoptions = {
                    message: error.response?.data.error ? error.response.data.error : error.message,
                    type: "error",
                };
                this.$store.dispatch('addToast', toastoptions);
            }).finally(() => {
                this.loading = false;
            })
        },
        async fetchChatHistoryMessages() {
            this.messageLoading = true;
            await this.getChatMessages({ feature: "map_my_data", resourceId: this.chat.resourceId }).then((response) => {
                this.messages = response.data ? response.data : null;
            }).catch((error) => {
                console.error("Error getting chat messages: ", error);
                let toastoptions = {
                    message: error.response?.data.error ? error.response.data.error : error.message,
                    type: "error",
                };
                this.$store.dispatch('addToast', toastoptions);
            }).finally(() => {
                this.messageLoading = false;
            })
        },
        deleteChat() {
            let data = {
                feature: "map_my_data",
                chats: [this.chat],
                screensize: 'xl'
            }   
            this.showModal({ component: "deleteChatHistory", data: data });
        },
        drawGraph(data) {
            const width = this.$refs.graphContainer.clientWidth;
            const height = 600;

            // Remove old SVG if it exists
            d3.select(this.$refs.graphContainer).select("svg").remove();

            // Create new SVG with zoom/pan support
            const svg = d3.select(this.$refs.graphContainer)
                .append("svg")
                .attr("width", width)
                .attr("height", height)
                .call(
                    d3.zoom()
                        .scaleExtent([0.5, 5]) // Min zoom 50%, max zoom 500%
                        .on("zoom", (event) => {
                            g.attr("transform", event.transform);
                        })
                );

            // Add a group element for panning/zooming
            const g = svg.append("g");
            this.simulation = d3.forceSimulation(data.nodes)
                .force("link", d3.forceLink(data.edges).id(d => d.id).distance(50))
                .force("charge", d3.forceManyBody().strength(-200))
                .force("center", d3.forceCenter(width / 2, height / 2));

            // Create edges (links)
            const link = g.selectAll(".link")
                .data(data.edges)
                .enter()
                .append("line")
                .attr("stroke", "#999")
                .attr("stroke-width", 1.5)
                .attr("stroke-opacity", 0.6);

            // Create node groups
            const node = g.selectAll(".node")
                .data(data.nodes)
                .enter()
                .append("g")
                .attr("class", "node")
                .call(
                    d3.drag()
                        .on("start", (event, d) => {
                            if (!event.active) this.simulation.alphaTarget(0.3).restart();
                            d.fx = d.x;
                            d.fy = d.y;
                        })
                        .on("drag", (event, d) => {
                            d.fx = event.x;
                            d.fy = event.y;
                        })
                        .on("end", (event, d) => {
                            if (!event.active) this.simulation.alphaTarget(0);
                            d.fx = null;
                            d.fy = null;
                        })
                );

            // Add circles for nodes
            node.append("circle")
                .attr("stroke", this.$store.state.darkMode ? "#1a1d23" : "white") // Border color
                .attr("stroke-width", 1.5) // Border thickness
                .attr("r", d => { // Circle radius
                    if (d.type === "prsn") return 15;
                    if (d.type === "org" || d.type === "hh") return 20;
                    return 12;
                })
                .attr("fill", d => { // Circle colour
                    if (d.type === "prsn") return "blue";
                    if (d.type === "ck") return "orange";
                    if (d.type === "statid") return "green";
                    if (d.type === "ip") return "purple";
                    if (d.type === "org" || d.type === "hh") return "red";
                    return "gray";
                });

            // Add icons inside the circles
            node.append("text")
                .attr("class", "fa")  // Font Awesome class for styling
                .attr("font-family", "FontAwesome")
                .attr("text-anchor", "middle")

                //.attr("x", d => (d.type === "prsn" || d.type === "cookie" || d.type === "statid" ? -6 : -4)) // Adjust horizontal position
                .attr("y", 5)  // Adjust vertical position
                .attr("x", 0)
                .attr("fill", this.$store.state.darkMode ? "#1a1d23" : "white")
                .attr("font-size", d => (d.type === "prsn" ? "14px" : d.type === "org" ? "18px" : d.type === "statid" ? "11px" : "13px"))
                .text(d => {
                    if (d.type === "prsn") return "\uf007"; // person_icon
                    if (d.type === "ck") return "\uf564"; // cookie icon
                    if (d.type === "statid") return "\uf390"; // statid icon
                    if (d.type === "ip") return "\uf6ff"; // network icon
                    if (d.type === "hh") return "\uf015"; // house icon
                    if (d.type === "org") return "\ue533"; // org icon
                    return "\u003f"; // unknown icon
                });

            // Tooltip for nodes
            node.on("mouseover", (event, d) => {
                const tooltip = document.createElement("div");
                tooltip.innerHTML = `<strong>Type: ${d.type}</strong><br>Domain: ${d.domain}<br>Key: ${d.key}`;
                tooltip.className = "graph-tooltip";
                tooltip.style.left = event.pageX + 5 + "px";
                tooltip.style.top = event.pageY + 5 + "px";
                document.body.appendChild(tooltip);
            });
            node.on("mouseout", () => {
                document.querySelectorAll(".graph-tooltip").forEach(tooltip => tooltip.remove());
            });

            // Update positions on simulation tick
            this.simulation.on("tick", () => {
                link
                    .attr("x1", d => d.source.x)
                    .attr("y1", d => d.source.y)
                    .attr("x2", d => d.target.x)
                    .attr("y2", d => d.target.y);
                node.attr("transform", d => `translate(${d.x},${d.y})`);
            });
        },
        onDetailPageOpenClose(value) {
            this.showCloseBtn = false;
            this.detailPageOpen = value;
        },
        onDetailPageHover(value) {
            this.showCloseBtn = value;
        },
        showinputFile() {
            this.showModal({
                component: "AgentInputFileViewer",
                data: {
                    title: 'Map My Data - File Viewer',
                    file: {
                        name: `InputFile.${this.fileType}`,
                        content: this.inputFile,
                    },
                    screensize: 'xl'
                }
            });
        },
        convertToRelativeTime(timestamp) {
            return relativeTime(Date.now(), dayjs(timestamp));
        },
        DateTimeFormat,
    },
    watch: {
        '$store.state.darkMode': {
            handler(newVal) {
                if (this.graphResponse) {
                    this.drawGraph(this.graphResponse)
                }
            }
        }
    },
    async beforeMount() {
        this.$emit("setChat", null);
        await this.fetchChatHistory();
    },
    emits: ["setChat"]
}
</script>
<style scoped>
.card-header {
    background-color: #F9FBFD;
    text-transform: uppercase;    
    color: #95AAC9;
    height:40px;
}
.collapsed .fa {
  transform: rotate(180deg);
}
.custom-class {
    width: 100%;
    overflow-x: scroll;
}
</style>
<style lang="scss">
.graph-tooltip {
    position: absolute;
    z-index: 1080;
    background-color: rgba(236, 240, 246, 0.95);
    backdrop-filter: blur(4px);
    color: var(--bs-dark);
    padding: 12px 14px;
    border-radius: 4px;
    font-size: 0.825rem;
    
    /* Tighter line-height for compact metadata */
    line-height: 1.4; 
    
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.25), 0 4px 6px -4px rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-left: 4px solid #3b82f6;
    min-width: 180px;
    transition: opacity 0.15s ease-in-out;
    pointer-events: none;

    strong {
        display: block;
        font-size: 0.75rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: #60a5fa;
        
        /* Reduced spacing around the divider line */
        margin-bottom: 10px; 
        padding-bottom: 10px;
        border-bottom: 1px solid rgb(199, 199, 199);
    }

    /* THE FIX: Catch the <br> right after the header and strip its layout presence */
    strong + br {
        display: none;
    }
}
.custom-instr.collapsed .custom-collapse-arrow-up {
    display: none !important;
}

.custom-instr:not(.collapsed) .custom-collapse-arrow-down {
    display: none !important;
}

.custom-instr-container {
    border: 1px solid #CBD5E1;
    border-radius: 7px;
    background-color: #F8FAFC;
    font-size: 0.9rem;
}

#customConfigCollapse {
    overflow: hidden;
    background-color: #fff;
    border-top: 1px solid #E2E8F0;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
}

.custom-config-badge {
    background-color: rgba(0, 217, 127, 0.2);
    color: #009f60;
    border: 1px solid #009f60;
    font-weight: 600;
    font-size: 0.7rem;
    padding: 0.15rem 0.6rem;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
}
</style>
<style lang="scss">
@use '../../theme/scss/_user-variables.scss' as *;
body.dark-mode {
    .graph-tooltip {
        background-color: $dark-border-color !important;
        color: #f1f5f9;
        
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.25), 0 4px 6px -4px rgba(0, 0, 0, 0.25);
        border: 1px solid rgba(255, 255, 255, 0.08);
        border-left: 4px solid #3b82f6;

        strong {
            color: #60a5fa;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        }
    }
}
</style>